import { UseTargetTableColumns } from './type';

/* file description */
export const useTargetTableColumns: UseTargetTableColumns = ({ field }) => {
  const { showFields } = field?.options || {};
  const targetTableColumns =
    showFields?.map((item: any) => {
      const resColumn: Record<string, any> = {
        dataIndex: item.key,
        title: item.realLabel,
      };
      return resColumn;
    }) || [];
  return {
    targetTableColumns,
  };
};
